import { render, staticRenderFns } from "./VContentEditable.vue?vue&type=template&id=6f565970&scoped=true"
import script from "./VContentEditable.vue?vue&type=script&lang=js"
export * from "./VContentEditable.vue?vue&type=script&lang=js"
import style0 from "./VContentEditable.vue?vue&type=style&index=0&id=6f565970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f565970",
  null
  
)

export default component.exports